export const TEXT_MAX_LENGTH = 1500;

export default {
  'Not at all':    'Not at all',
  'Somewhat':      'Somewhat',
  'Significantly': 'Significantly',
  'Not a goal':    'Not a goal of this activity'
}
